import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Button, Field, Input, Note } from '../components/ui'
import { useSession } from '../lib/session'
import { AuthLayout } from './AuthLayout'

export function Login() {
  const { signIn } = useSession()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await signIn(email, password)
      navigate('/', { replace: true })
    } catch (cause) {
      // The server deliberately returns one message for every failure — wrong
      // password, pending approval, disabled, no such account. Showing it
      // verbatim keeps the client from inventing a more specific one.
      setError(cause instanceof Error ? cause.message : 'Could Not Sign In')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthLayout title="Sign in">
      {error && <Note tone="error">{error}</Note>}
      <form onSubmit={submit} noValidate>
        <Field label="Email">
          <Input
            type="email"
            value={email}
            autoComplete="username"
            required
            onChange={(event) => setEmail(event.target.value)}
          />
        </Field>
        <Field label="Password">
          <Input
            type="password"
            value={password}
            autoComplete="current-password"
            required
            onChange={(event) => setPassword(event.target.value)}
          />
        </Field>
        <Button type="submit" variant="primary" disabled={busy} className="w-full">
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
      <p className="mt-4 text-sm" style={{ color: 'var(--text-secondary)' }}>
        <Link to="/forgot-password" style={{ color: 'var(--brand-ink)' }}>
          Forgotten Your Password?
        </Link>
      </p>
      <p className="mt-1 text-sm" style={{ color: 'var(--text-secondary)' }}>
        No account? <Link to="/register" style={{ color: 'var(--brand-ink)' }}>Register</Link>
      </p>
    </AuthLayout>
  )
}
